var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiPrompt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "auto_graph"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7473 14.2533L16.0007 13L18.7473 11.7466L20.0007 8.99996L21.254 11.7466L24.0007 13L21.254 14.2533L20.0007 17L18.7473 14.2533ZM5.33398 19.6666L6.58732 16.92L9.33398 15.6666L6.58732 14.4133L5.33398 11.6666L4.08065 14.4133L1.33398 15.6666L4.08065 16.92L5.33398 19.6666ZM11.334 13L12.7873 9.78663L16.0007 8.33329L12.7873 6.87996L11.334 3.66663L9.88065 6.87996L6.66732 8.33329L9.88065 9.78663L11.334 13ZM6.00065 28.3333L14.0007 20.32L19.334 25.6533L30.6673 12.9066L28.7873 11.0266L19.334 21.6533L14.0007 16.32L4.00065 26.3333L6.00065 28.3333Z",
    fill: "#008F8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPrompt);
export default __webpack_public_path__ + "static/media/AIPrompt.8c57046146690ac0cde3a561b3528353.svg";
export { ForwardRef as ReactComponent };